import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { LoginPage } from "@/shared/pages/auth/login";
import { requireGuest } from "@/shared/lib/auth-guard";

export const Route = createFileRoute("/auth/login")({
  beforeLoad: requireGuest,
  component: LoginRoute,
});

function LoginRoute() {
  return (
    <AuthLayout>
      <LoginPage />
    </AuthLayout>
  );
}
